import React, { useState } from 'react';
import styles from '../cssmodules/sidebar.module.css';
import barLogo from '../assets/images/BarAssociationDeharadunLogo.png'
import { useSelector } from 'react-redux';

const Header = () => {
  const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };
  const styleAnchor = {
    textDecoration: 'none'
  };

  const userData = useSelector(state => state.auth.userData?.authUser);
  const isLoggedIn = useSelector(state => state.auth?.isLoggedIn)
  const isFingerPrintVerified = useSelector(state => state.fingerprint?.isFingerprintVerified)

  const getHref = () => {
    if (!isLoggedIn) return '/';

    if (isFingerPrintVerified && isLoggedIn) {
      switch (userData.role) {
        case 'Super Admin':
          return '/Dashboard';
        case 'Cashier':
          return '/Accounts';
        case 'Accountant':
          return '/Fees';
        case 'Computer Operator':
          return '/Verification';
        default:
          return '/';
      }
    }
  };
  

 

  
  return (
    <header  className={styles.fixed_header}>
      <nav  className={`${styles.navbar}`}>
        {/* Logo */}
        <a style={styleAnchor}  href={getHref()} className={`${styles.logo} ms-md-5 ms-0`}>
          <img
            className="rounded-full"
            src={barLogo}
            alt="Logo"
            width="50"
            height="50"
          /> &nbsp;
          <span>Bar Association Dehradun</span>
        </a>
        <ul className={`${styles.navMenu} ${isActive ? styles.active : ''}`}>
          <li>
            <a href="#home" className={styles.navLink}>Dashboard</a>
          </li>
          <li>
            <a href="#" className={styles.navLink}>Fees</a>
          </li>
          <li>
            <a href="#" className={styles.navLink}>Verification</a>
          </li>
          <li>
            <a href="#contact" className={styles.navLink}>Accounts</a>
          </li>
          <li>
            <a href="#contact" className={styles.navLink}>Voating</a>
          </li>
        </ul>
        <div className={`${styles.hamburger} ${isActive ? styles.active : ''}`} onClick={toggleMenu}>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
